var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { Typography } from '@snack-uikit/typography';
import { extractSupportProps } from '@snack-uikit/utils';
import { APPEARANCE, COLOR, SIZE } from '../constants';
import styles from './styles.module.css';
/**
 * Компонент Promo Tag
 */
export function PromoTag(_a) {
    var { appearance = APPEARANCE.Primary, color = COLOR.Accent, size = SIZE.Xxs, className, text, beforeContent, afterContent, onClick } = _a, props = __rest(_a, ["appearance", "color", "size", "className", "text", "beforeContent", "afterContent", "onClick"]);
    const displayNodes = size !== SIZE.Xxs;
    const clickAttributes = onClick ? { role: 'button', tabIndex: 0, onClick } : {};
    const Label = size === SIZE.S ? Typography.SansLabelM : Typography.SansLabelS;
    return (_jsxs("div", Object.assign({ className: cn(styles.promoTag, className) }, extractSupportProps(props), { "data-appearance": appearance, "data-color": color, "data-size": size }, clickAttributes, { children: [displayNodes && beforeContent, Boolean(text) && (_jsx(Label, { className: styles.labelWrapper, tag: 'span', children: text })), displayNodes && afterContent] })));
}
